import type { DepartmentType } from "@/types"
import { ColumnDef } from "@tanstack/react-table"

import { DataTableColumnHeader } from "../../data-table"
import { DepartmentOperation } from "../operations/departments-operations"

export const departmentsColumns: ColumnDef<DepartmentType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <DepartmentOperation data={row.original} />
        </div>
      )
    },
  },
]
